
import "../../Foundation/stylable/typography.st.css.js";
import "../../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Affix";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Affix__root","text-tiny-thin":"wds_1_76_1_StylableTypography__text-tiny-thin","text-small-normal":"wds_1_76_1_StylableTypography__text-small-normal","text-small-thin":"wds_1_76_1_StylableTypography__text-small-thin","text-medium-normal":"wds_1_76_1_StylableTypography__text-medium-normal","text-medium-thin":"wds_1_76_1_StylableTypography__text-medium-thin"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




